// This is same as: OktaConfigInfo of packages\libs\authz\src\contracts.ts and should either replace or merge these together
export type OktaAuthBaseOptions = {
  clientId: string;
  issuer: string;
  scopes?: string[];

  assertClaims: {
    aud: string;
    cid: string;
  };
  cacheMaxAge: number;
  jwksRequestsPerMinute: number;
  pkce: boolean;
};

export type A1AuthOptions = OktaAuthBaseOptions;

export enum TenantType {
  Okta = 'OKTA',
}

export const TenantTypes = Object.values(TenantType);

export const OktaTenantCode = {
  OktaB2E: `${TenantType.Okta}-B2E`,
  OktaGDC: `${TenantType.Okta}-B2B_GDC`,
  OktaLSS: `${TenantType.Okta}-LSS`,
  OktaEwacs: `${TenantType.Okta}-EWACS`,
  OktaBRB: `${TenantType.Okta}-BRB`,
  OktaA1Origin: `${TenantType.Okta}-A1_Origin`,
} as const;

export const OktaTenantCodes = Object.values(OktaTenantCode);

export const TenantTypeWithTenantCodesMap = {
  [TenantType.Okta]: OktaTenantCodes,
};

export const TenantCode = { ...OktaTenantCode };
export const TenantCodesList = Object.values(TenantCode);

export type AppAuthOptions = {
  tenantType: TenantType;
  tenantCode: string;
  displayName?: string;
  loginUrl?: string;
  sessionUrl?: string;
  // If any additional config needs to be provided for other tenant types.
  // Use something like `config: OktaAuthBaseOptions | CustomTenantOptions`.
  config: OktaAuthBaseOptions;
};

export type AuthOptionsConfig = AppAuthOptions['config'];

export type AppAuthOptionsList = AppAuthOptions[];
